// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Statistics_mainContainer__29ApW","cardRow":"Statistics_cardRow__39CRP"};